<div class="graph-header">
  <h3 class="graph-title">
    {{ title }}
    @if (infoDescription) {
      <app-info-tooltip
        [heading]="title"
        [description]="infoDescription"
      ></app-info-tooltip>
    }
  </h3>
</div>

<div class="graph-body common-graph-wrapper">
  <canvas
    baseChart
    [type]="chartType"
    [data]="chartData"
    [options]="finalChartOptions"
  >
  </canvas>
</div>
